<script>
import LanguagePicker from './language/LanguagePicker';
// import Skiplinks from './Skiplinks';

export default {
    name: 'Identity',
    components: { LanguagePicker },
    data() {
        return {
            hostname: this.$config.host,
            FAQLINK: this.$t('components.faq.faqlink', { host: this.hostname })
        }
    },
    props: {
        displayFaq: {
            type: Boolean,
            required: false,
            default: true
        },
        displayLanguagePicker: {
            type: Boolean,
            required: false,
            default: true
        },
        homeLink: {
            type: String,
            required: false,
            default: 'Home'
        }
    },
    computed: {
        hasLanguages() {
            return this.$store.state.languages.all.length > 1;
        },
        pageHeaderImage() {
            if (this.$route.meta.pageHeader) {
                if (this.$route.meta.pageHeader === 'error') {
                    return 'assets/img/artwork/CHA_app_Graphics-18.png';
                } else {
                    return 'assets/img/artwork/CHA_app_Graphics-18.png'
                }
            } else {
                // standard
                // return 'assets/img/artwork/coronacheck-header-regular.svg'
                return 'assets/img/artwork/CHA_app_Graphics-18.png'
            }
        },
        pageHeaderLeftImage() {
            if (this.$route.meta.pageHeader) {
                if (this.$route.meta.pageHeader === 'error') {
                    return 'assets/img/artwork/logo_new_largerpowered-01.png';
                } else {
                    return 'assets/img/artwork/logo_new_largerpowered-01.png'
                }
            } else {
                // standard
                // return 'assets/img/artwork/coronacheck-header-regular.svg'
                return 'assets/img/artwork/logo_new_largerpowered-01.png'
            }
        }
    },
    methods: {
        // todo faq href for multi language
    },
    updated() {
        this.FAQLINK = this.$t('components.faq.faqlink', { host: this.hostname });
    }
}
</script>

<template>
    <div class="Identity">
        <div style="height: 1px;background: black;"></div>
        <!-- <Skiplinks/> -->
        <!-- <div class="logo">
            <a href="https://coronacheck.nl/">
                <img
                    :alt="$t('logo-government')"
                    width="45"
                    src="assets/img/rijksoverheid/label_ministerie.svg"/>
            </a>
        </div> -->

        <div class="pagewrap">
            <div class="Identity__image-container">
                <img
                    class="Identity__image"
                    alt=""
                    width="246"
                    height="150"
                    :src="pageHeaderImage"/>
            </div>

        </div>
        <router-link class="CoronaCheck-logo" :to="{ name: this.homeLink }">
                <img class="Identity__image__coronacheck" alt="" :src="pageHeaderLeftImage"/>
        </router-link>
        <!-- <a
            href="#"
            class="CoronaCheck-logo">
              <img
                    class="Identity__image__coronacheck"
                    alt=""
                    :src="pageHeaderLeftImage"/>
        </a> -->
        <a v-if="displayFaq" :href="this.FAQLINK" target="_blank" class="header__layout__faq-link" style="color:#fff;text-decoration:none;">
            {{$t('faq')}}
        </a>
        <LanguagePicker v-if="hasLanguages && displayLanguagePicker" />
    </div>
</template>

<style lang="scss">
@import "@/styles/variables/index";

.Identity {
    // background: $color-RO_lightblue;
    background: #7ccbc8;
    position: relative;
    height: 225px;
    border-bottom: 12px;
    border-bottom-color: blue;

    .pagewrap {
        height: 100%;

        .Identity__image-container {
            display: flex;
            align-items: flex-end;
            height: 100%;
            overflow: hidden;

            .Identity__image {
                display: block;
                height: auto;
                margin-left: 230px;
                max-width: 343px;
                width: 100%;
            }
        }
    }

    .Identity__image__coronacheck {
                display: block;
                height: auto;
                max-width: 246px;
                width: 246px;
                height: 150px;
    }

    .logo {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
    }

    .CoronaCheck-logo {
        position: absolute;
        left: 20px;
        top: 38px;
        color: $color-RO_darkblue;
        font-weight: 700;
        font-size: 20px;
        text-decoration: none;
        padding: 4px;

        &:hover {
            text-decoration: underline;
        }
    }

    @include mobile() {
        justify-content: center;

        .pagewrap {
            padding: 0;

            .Identity__image-container {

                .Identity__image {
                    margin: 0 auto;
                    height: 150px;
                    width:224px;
                }
            }
        }

        .CoronaCheck-logo {
            top: 21px;
        }

        .Identity__image__coronacheck {
                display: block;
                height: auto;
                max-width: 162px;
                width: 162px;
                height: 99px;
                margin-top:-30px;
                margin-left:-20px;
        }

        .Identity__tools {

            .Identity__faq {
                display: none;
            }
        }
    }
}
</style>
